export default __webpack_public_path__ + "static/konsekvent-bruk1-363b575f7434aa526d2c733634c62eac.png";